import $ from 'jquery'
var edplanner = (function () {
    var q, f = null,
        a = null,
        m = null,
        k = 0,
        h = false,
        e = null,
        b = function (v) {
            var s, r = $(this),
                w = 400,
                u = r.data("slideIndex"),
                t = $(q[k]);
            if (isNaN(u) || u === k || h) {
                return false
            } else {
                s = q[u];
                h = true
            }
            t.data("nextSlide", s).fadeOut(w, function () {
                var x = $(this);
                x.addClass("hide").css("display", "block");
                $(x.data("nextSlide")).css("display", "none").removeClass("hide").fadeIn(w, function () {
                    h = false
                }).find("p.storyButton").css("display", "none").fadeIn(w).end()
            }).find("p.storyButton").fadeOut(w, function () {
                $(this).css("display", "block")
            }).end();
            $("ul#slideShowController").fadeOut(w, function () {
                $(this).fadeIn(w)
            });
            m.find("img").attr("src", "/images/homepage/controller.png").end();
            r.find("img").attr("src", "/images/homepage/controller-active.png").end().blur();
            k = u;
            if (v && v.preventDefault) {
                if (f) {
                    clearTimeout(f);
                    f = null
                }
                v.preventDefault()
            }
            return false
        },
        j = function () {
            var s, r = (k + 1) >= q.length ? 0 : k + 1;
            if (f) {
                clearTimeout(f);
                f = null
            }
            $("ul#slideShowController a").each(function () {
                var t = $(this);
                if (t.data("slideIndex") === r && typeof s === "undefined") {
                    s = this
                }
            });
            if (typeof s !== "undefined") {
                b.call(s);
                f = setTimeout(j, 7000)
            }
        },
        o = function () {
            var r = $(this);
            if (r.data("oTarget")) {
                $(r.data("oTarget")).removeClass("hide");
                r.addClass("activeLink").blur()
            }
        },
        i = function () {
            var r = $(this);
            if (r.data("oTarget")) {
                $(r.data("oTarget")).addClass("hide");
                r.removeClass("activeLink").blur()
            }
        },
        g = function () {
            $(".expandBox div").removeClass("hide");
            $(".expandBox a").addClass("activeLink").blur()
        },
        d = function () {
            $(".expandBox div").addClass("hide");
            $(".expandBox a").removeClass("activeLink").blur()
        },
        l = function () {
            var s = this.innerHTML.indexOf("View"),
                t, r = "";
            if (s !== -1) {
                t = "Hide"
            } else {
                if ((s = this.innerHTML.indexOf("Hide")) !== -1) {
                    t = "View"
                } else {
                    return
                }
            }
            if (s > 0) {
                r += this.innerHTML.slice(0, s)
            }
            r += t;
            if (s + 4 < this.innerHTML.length) {
                r += this.innerHTML.slice(s + 4)
            }
            this.innerHTML = r
        },
        p = function () {
            $(this).toggleClass("activeLink");
            $(this).text($(this).text() == "Expand All" ? "Collapse All" : "Expand All")
        },
        n = function () {
            var s = this,
                t = null,
                r = function () {
                    var u = $(s).children("ul"),
                        v = u.position(),
                        z = v && typeof v.left === "number" && v.left >= 0 ? v.left : -9999,
                        y = v && typeof v.top === "number" && v.top >= 0 ? v.top : -9999,
                        A = u.outerHeight(),
                        w = u.outerWidth(),
                        x = u.css("z-index") - 1;
                    if (t) {
                        clearTimeout(t);
                        t = null
                    }
                    e.insertBefore(u).css({
                        "background-color": "#FFFFFF",
                        height: A + "px",
                        left: z + "px",
                        position: "absolute",
                        top: y + "px",
                        width: w + "px",
                        "z-index": x
                    }).data("bDomOff", false)
                };
            if (!e) {
                e = $('<iframe id="menuIFrame" />').data("bDomOff", true).attr("src", 'javascript:"";')
            }
            t = setTimeout(r, 5)
        },
        c = function () {
            if (e && !e.data("bDomOff")) {
                e.detach().data("bDomOff", true)
            }
        };
    return function () {
        var r = $(document);
        r.find("a[href^='http']").click(function (s) {
            if (ga) {
                ga("send", "event", "external-link", "click", this.href)
            }
        }).end().find("a[href^='http']").click(function () {
            
        }).end().find("a:not([href^='http'])").click(function () {
            
        }).end().find("a[rel=external],.contentButton em[rel=external],a[rel=generic],a[rel=pdf],a[rel=excel],a[rel=ppt],map#Map area").on("click", function () {
            var u = (screen.width / 1.5);
            var v = (screen.height / 1.5);
            var s = (screen.width - u) / 2;
            var t = (screen.height - v) / 2;
            window.open(this.href, "External_Link", "height=500,width=800,resizable=yes,top=" + t + ",left=" + s + ",scrollbars=yes,menubar=yes,toolbar=yes,status=yes,location=yes");
            return false
        }).end().find(".detailsBox,.answerBox").each(function () {
            var s = "View " + this.className.replace(/(details|answer)Box/, function (u, t) {
                return t.charAt(0).toUpperCase() + t.slice(1)
            });
            $('<p class="detailLink"><a href="#">' + s + "</a></p>").find("a").toggle(o, i).data("oTarget", this).click(l).end().insertBefore(this)
        }).addClass("hide").end().find(".blinds").each(function () {
            var t = $(this),
                s = t.children().not(":first-child").wrapAll("<div />").addClass("hide");
            t.children().first().wrapInner('<a href="#" />').find("a").toggle(o, i).data("oTarget", s).end()
        }).end().find(".expandBox").each(function () {
            var u = $(this),
                t = u.children().not(":first-child").wrapAll("<div />"),
                s = u.children("div").addClass("hide");
            u.children().first().addClass("first").wrapInner('<a href="#" />').find("a").click(function () {
                if ($(this).hasClass("activeLink")) {
                    $(this).removeClass("activeLink");
                    s.addClass("hide")
                } else {
                    $(this).addClass("activeLink");
                    s.removeClass("hide")
                }
                return false
            }).end()
        }).end().find(".expandBox:first").each(function () {
            $('<p class="expandAll"><a href="#">Expand All</a></p>').find("a").toggle(g, d).data("oTarget", this).click(p).end().insertBefore(this)
        }).end().find("ul#slideShow").each(function () {
            var t, s, u;
            a = $(this);
            q = a.children("li");
            m = $('<ul id="slideShowController" />').insertAfter(a);
            for (t = 0, s = q.length; t < s; t += 1) {
                u = t > 0 ? "/images/homepage/controller.png" : "/images/homepage/controller-active.png";
                $('<li><a href="#"><img src="' + u + '" alt="Image #' + (t + 1) + ' Slide" height="15" width="15" /></a></li>').find("a").data("slideIndex", t).click(b).end().appendTo(m)
            }
            $(window).bind("load", function () {
                f = setTimeout(j, 7000)
            })
        }).end().find("input#sp-q").bind("focus", function () {
            this.value = this.value === "Enter Search Term" ? "" : this.value
        }).bind("blur", function () {
            this.value = this.value.replace(/^\s+|\s+$/g, "").length > 0 ? this.value : "Enter Search Term"
        }).val("Enter Search Term").end();
        if (typeof document.body.style.maxHeight === "undefined") {
            r.find("ul#siteNav").children("li").hover(function () {
                $(this).addClass("navHover")
            }, function () {
                $(this).removeClass("navHover")
            }).end()
        }
        if (document.all && !window.opera && r.find("object,embed").length > 0) {
            r.find("ul#siteNav").children("li").hover(n, c).end();
            e = $('<iframe id="menuIFrame" />').data("bDomOff", true).attr("src", 'javascript:"";')
        }
    }
}());
$("document").ready(edplanner);